const mapValues_ = require('lodash/mapValues')

const { assertDatasetTypeIsRouter } = require('./datasetApiAssertions')

const routerDatasetApiCreator = ({ recordStore, getState, datasetType }) => {
  const routerDatasetApi = {
    async getNextDynamicPage() {
      return await recordStore(getState()).matchWith({
        Pending: () => null,
        Ready: ({ instance }) => {
          return instance.getNextDynamicPage()
        }
      })
    },

    async getPreviousDynamicPage() {
      return await recordStore(getState()).matchWith({
        Pending: () => null,
        Ready: ({ instance }) => {
          return instance.getPreviousDynamicPage()
        }
      })
    }
  }
  return mapValues_(routerDatasetApi, (fn, functionName) => (...args) => {
    assertDatasetTypeIsRouter(datasetType, functionName)
    return fn(...args)
  })
}

module.exports = routerDatasetApiCreator



// WEBPACK FOOTER //
// ./dataset-controller/routerDatasetApi.js